export function setAuthCookie(cookie, auth, req) {
  let cookies = cookie;
  if (process.env.IS_BROWSER) {
    cookies = cookie();
  } else {
    cookies = cookie(req);
  }
  cookies.remove("auth");
  if (auth !== false) {
    let exdate = new Date();
    exdate.setDate(exdate.getDate() + 365);
    cookies.set("auth", JSON.stringify(auth), {
      expires: exdate
    });
    return true;
  }
  return false;
}

export function getAuthCookie(cookie, req) {
  let cookies = cookie;
  if (process.env.IS_BROWSER) {
    cookies = cookie();
  } else {
    cookies = cookie(req);
  }

  let c = cookies.get("auth");
  if (c === undefined) return false;

  let auth = JSON.parse(c);
  if (auth === undefined) return false;

  return auth;
}

export function clearAuthCookie(cookie, req) {
  let cookies = cookie;
  if (process.env.IS_BROWSER) {
    cookies = cookie();
  } else {
    cookies = cookie(req);
  }

  cookies.remove("auth");
}



// WEBPACK FOOTER //
// ./src/common/lib/auth.js